import React from 'react';
import { Box, styled } from '@mui/material';
import { Link } from 'react-router-dom';

const StyledWrapper = styled(Box)(() => ({
    padding: '10px 0 10px 0',
    marginBottom: '3px',
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
}));

const StyledLink = styled(Link)(() => ({
    color: '#999999',
}));
const StyledBox = styled(Box)(() => ({
    color: '#999999',
}));

export const Breadcrumb: React.FC<{
    collection?: { title: string; handle: string };
    product?: { title: string; handle: string };
}> = (props) => {
    const { collection, product } = props;

    return (
        <StyledWrapper>
            <StyledLink to={'/collections/' + collection.handle}>
                {collection.title}
            </StyledLink>
            <StyledBox>/</StyledBox>
            <StyledLink to={'/products/' + product.handle}>
                {product.title}
            </StyledLink>
        </StyledWrapper>
    );
};
